import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

interface ConsultantState {
  consultant: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: ConsultantState = {
  consultant: null,
  loading: false,
  error: null,
};

export const fetchConsultant = createAsyncThunk(
  "consultant/fetchConsultant", 
  async (uid: string, { rejectWithValue }) => {
  try {
    const { response } = await Ows.handleRequest("Otys.Services.UserService.getDetail", [
      uid,
      {
        uid: true,
        Person: {
          firstName: true,
          infix: true,
          lastName: true,
          emailPrimary: true,
        },
      },
    ]);

    if (response) {
      return response;
    } else {
      return rejectWithValue("No consultant found with this email.");
    }
  } catch (error: any) {
    return rejectWithValue("Failed to fetch consultant.");
  }
});

const consultantSlice = createSlice({
  name: "consultant",
  initialState,
  reducers: {
    resetConsultant: (state) => {
      state.consultant = null;
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsultant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConsultant.fulfilled, (state, action) => {
        state.consultant = action.payload;
        state.loading = false;
      })
      .addCase(fetchConsultant.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { resetConsultant, clearError } = consultantSlice.actions;
export default consultantSlice.reducer;
